var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTermineVereinbaren = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 53,
  height: 57,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m17.053 37.084 7.143 7.326M24.195 44.41 37.33 31.133M7.605 6.41h37.791c2.996 0 5.53 2.518 5.53 5.494v37.542c0 2.976-2.534 5.494-5.53 5.494H7.605c-2.996 0-5.53-2.518-5.53-5.494V11.904c0-2.976 2.534-5.494 5.53-5.494ZM39.635 2.06v8.699M13.365 2.06v8.699M2.074 21.06h48.852",
  stroke: "#CC0100",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgTermineVereinbaren;